var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "landing-cnt row" }, [
        _c("div", { staticClass: "bg-heart" }),
        _vm._v(" "),
        _c("div", { staticClass: "bg-image" }),
        _vm._v(" "),
        _c("div", {
          staticClass: "col-12 d-landscape-none d-xl-none d-flex main-block-xs"
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "text-block-ctn col-desktop-6 col-landscape-6 col-xl-6 col-12 d-flex my-auto pt-4 pt-md-0"
          },
          [
            _c("div", { staticClass: "text-ctn my-auto" }, [
              _c("h1", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("os360-empresas.main-block.title"))
                }
              }),
              _vm._v(" "),
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("os360-empresas.main-block.subtitle")))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "d-mobile-rotated-none" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("os360-empresas.main-block.paragraph")) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-cnt mt-0 mt-mobile-rotated-4 mt-xl-5" },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "mr-2 mr-md-4",
                      attrs: { pseudoShadow: "" },
                      on: { click: _vm.goToContactForm }
                    },
                    [_vm._v("+ Info\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      attrs: {
                        white: "",
                        pseudoShadow: "",
                        textColor: _vm.BLUE_COLOUR
                      },
                      on: { click: _vm.goTo360SignIn }
                    },
                    [_vm._v("\n              " + _vm._s(_vm.$t("log-in")))]
                  )
                ],
                1
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "section py-5", attrs: { id: "service-blocks" } },
        [
          _c(
            "b-row",
            {
              staticClass: "neu-cards-ctn m-auto text-center",
              attrs: { cols: "1", "cols-sm": "2", "cols-xl": "3" }
            },
            [
              _c("b-col", { staticClass: "my-auto" }, [
                _c("div", { staticClass: "box bg-heart-sm" }, [
                  _c("div", { staticClass: "my-auto" }, [
                    _c("h3", { staticClass: "main-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("os360-empresas.blocks.title")) + " "
                      ),
                      _c("br"),
                      _vm._v("opensalud360")
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("h5", { staticClass: "d-block" }, [
                      _vm._v(
                        _vm._s(_vm.$t("os360-empresas.blocks.what-do-you-need"))
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.blocks, function(block) {
                return _c("b-col", { key: block.id, staticClass: "my-auto" }, [
                  _c("div", { staticClass: "box my-auto" }, [
                    _c(
                      "div",
                      { staticClass: "my-auto" },
                      [
                        _c("base-icon", {
                          staticClass: "d-block",
                          attrs: {
                            blue: "",
                            src: block.img,
                            alt: block.title,
                            size: "lg"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "box-title mt-3" }, [
                          _vm._v(_vm._s(block.title))
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(block.description))]),
                        _vm._v(" "),
                        _vm.inMx &&
                        block.title ===
                          _vm.$t("os360-empresas.blocks.opensaludpass.title")
                          ? _c("b-badge", { staticClass: "mt-4" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "os360-empresas.blocks.opensaludpass.soon"
                                  )
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              }),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "my-auto",
                  attrs: { cols: "12", sm: "6", xl: "8" }
                },
                [
                  _c("div", { staticClass: "box bg-heart-big" }, [
                    _c(
                      "div",
                      { staticClass: "my-auto" },
                      [
                        _c("h3", { staticClass: "d-block" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("os360-empresas.blocks.more-info-question")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "base-button",
                          {
                            staticClass: "mt-2 mt-md-4",
                            attrs: { white: "", shadow: "" },
                            on: { click: _vm.goToContactForm }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t(
                                    "os360-empresas.big-companies.request-info"
                                  )
                                )
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.inMx
        ? _c(
            "b-row",
            {
              staticClass: "section-black-list",
              attrs: { id: "social-benefit" }
            },
            [
              _c(
                "b-col",
                {
                  staticClass: "d-none d-xl-block",
                  attrs: { md: "12", xl: "6" }
                },
                [_c("div", { staticClass: "col-bg ml-lg-auto" })]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "content my-auto mx-auto",
                  attrs: { md: "12", xl: "6" }
                },
                [
                  _c("h3", [
                    _vm._v(
                      _vm._s(_vm.$t("os360-empresas.social-benefit.subtitle"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "subtitle pt-4" }, [
                    _c(
                      "div",
                      { staticClass: "subtitle-list subtitle-list-large" },
                      _vm._l([1, 2, 3, 4, 5, 6], function(i) {
                        return _c(
                          "b-row",
                          { key: i },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "tick-mobile",
                                attrs: { cols: "1" }
                              },
                              [
                                _c(
                                  "p",
                                  [
                                    _c("base-icon", {
                                      attrs: {
                                        src:
                                          "/static-appopensalud/img/icons/360/social-benefit-" +
                                          i +
                                          ".svg",
                                        width: "30",
                                        height: "30"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "my-auto",
                                attrs: {
                                  cols: "10",
                                  offset: "1",
                                  "offset-md": "0"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "os360-empresas.social-benefit.list." +
                                            i
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticStyle: { color: "white" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "os360-empresas.social-benefit.security-description"
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-row", { staticClass: "cert-icons mt-3 mt-md-5" }, [
                    _c(
                      "div",
                      { staticClass: "d-inline-block" },
                      [_c("ISO27001Logo")],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-inline-block" }, [
                      _c("img", {
                        staticClass: "vertical",
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/Logo/gdpr.webp"
                        }
                      })
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "section mx-auto py-5", attrs: { id: "big-companies" } },
        [
          _c(
            "div",
            { staticClass: "my-auto text-center" },
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c("h5", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("os360-empresas.companies")) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c("h6", {
                  staticClass: "desktop-fix-subtitle",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("os360-empresas.companies2"))
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "logos-ctn col-12", attrs: { cols: "12" } },
                _vm._l(_vm.groupsOfLogos, function(groupOfLogos) {
                  return _c(
                    "b-row",
                    {
                      key: _vm.groupsOfLogos.indexOf(groupOfLogos),
                      staticClass: "logos-row mt-0 mt-sm-5"
                    },
                    _vm._l(groupOfLogos, function(logo) {
                      return _c(
                        "b-col",
                        {
                          key: logo.companyName,
                          attrs: {
                            cols: "12",
                            sm: "2",
                            "offset-sm":
                              groupOfLogos.indexOf(logo) == 0 ? 1 : null,
                            "offset-md":
                              groupOfLogos.indexOf(logo) == 0 ? 1 : null,
                            md: "2"
                          }
                        },
                        [
                          _c("img", {
                            style: {
                              width:
                                logo.width &&
                                !_vm.$uiHelpers.isMobile &&
                                !_vm.$uiHelpers.isTablet
                            },
                            attrs: { src: logo.logo, alt: logo.companyName }
                          })
                        ]
                      )
                    }),
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          staticClass: "section-invert",
          attrs: { id: "psychological-attention" }
        },
        [
          _c(
            "b-col",
            {
              staticClass: "content my-auto mx-auto",
              attrs: { md: "12", xl: "6" }
            },
            [
              _c("h3", [
                _vm._v(
                  _vm._s(_vm.$t("os360-empresas.psychological-attention.title"))
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "subtitle" },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "pr-lg-5 pr-sm-0",
                          attrs: { sm: "12", lg: "12" }
                        },
                        [
                          _c("div", [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "os360-empresas.psychological-attention.subtitle"
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "os360-empresas.psychological-attention.text"
                                )
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "os360-empresas.psychological-attention.subtitle-2"
                                )
                              )
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("b-col", { attrs: { sm: "12", lg: "12" } }, [
                        _c("div", [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "os360-empresas.psychological-attention.title-2"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "os360-empresas.psychological-attention.text-2"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "d-block d-desktop-none d-xl-none",
                          attrs: {
                            src:
                              "/static-appopensalud/img/logos/logo-menttum-grande-blanco.png",
                            alt: "Menttum"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "base-button",
                        {
                          staticClass: "mt-5",
                          attrs: { white: "" },
                          on: { click: _vm.goToContactForm }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t("os360-empresas.more-information-btn")
                              )
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "d-none d-desktop-block d-xl-block",
              attrs: { md: "12", xl: "6" }
            },
            [
              _c("img", {
                staticClass: "m-auto justify-content-center align-items-center",
                attrs: {
                  src: "/static-appopensalud/img/logos/logo-menttum-grande.png",
                  alt: "Menttum"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "col-bg ml-xl-auto" })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("companies-contact-form", {
        staticClass: "pb-5 pb-xl-0",
        staticStyle: {
          "margin-top": "0px !important",
          "padding-top": "3rem !important"
        },
        attrs: {
          forCompaniesOnly: "",
          hideWebsite: "",
          showReason: "",
          subtitle: _vm.$t("os360-empresas.opensalud-empresas.form-subtitle"),
          callbackPath: "/opensalud360/empresas/gracias"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14e697a9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14e697a9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/opensalud/EmpresasNew.vue
// module id = 3770
// module chunks = 48